module.exports = __webpack_public_path__ + "img/greatsword_of_fn.fe5189e2.png";